import React from 'react';
import loadable from 'utils/loadable.jsx';
import useStorage from 'utils/storage/useStorage.js';
import { requiredString } from '../Form4/useConvertSchema.js';

const EditorMD = loadable(() => import('./md/index.jsx'), {
  fallback: null,
});

const EditorDelta = loadable(() => import('./delta/index.jsx'), {
  fallback: null,

});

function MDEditor(props) {
  const [editor] = useStorage('useMDEditor', false);
  const Editor = editor ? EditorMD : EditorDelta;
  return <Editor {...props} />;
}

MDEditor.displayName = 'MDEditor';

MDEditor.getSchema = requiredString;

export default MDEditor;
